// extracted by mini-css-extract-plugin
export var container = "_5l-0";
export var error = "_5l-9";
export var label = "_5l-5";
export var light = "_5l-6";
export var md = "_5l-3";
export var sm = "_5l-2";
export var thin = "_5l-8";
export var thinBold = "_5l-7";
export var vertical = "_5l-4";
export var xs = "_5l-1";